import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
// import { useAuth } from "../contexts/AuthContext";

// interface ProtectedRouteProps {
//   permission?: string;
//   children?: React.ReactNode;
// }

interface JwtPayload {
  exp: number;
}

const isTokenValid = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

export const isAuthenticated = () => {
  const token = localStorage.getItem("accessToken");
  return token && isTokenValid(token);
};

const ProtectedRoute: React.FC = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

// export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permission, children }) => {
//   const { isAuthenticated, isLoading, hasPermission } = useAuth();

//   if (isLoading) {
//       return <div>Loading...</div>;
//   }

//   if (!isAuthenticated) {
//       return <Navigate to="/login" replace />;
//   }

//   if (permission && !hasPermission(permission)) {
//       return <Navigate to="/unauthorized" replace />;
//   }

//   return <>{children}</>;
// };

export default ProtectedRoute;
